import { ColorPallet } from "../../utils/colorPallet";
export const styles = {
    modalBox: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        borderRadius: '12px',
        transform: 'translate(-50%, -50%)',
        backgroundColor: ColorPallet.neutralWhite,
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
        p: 4,
       
        width: "50%", // Default width
                    maxWidth: "600px", // Maximum width for large screens
                    ["@media (max-width:960px)"]: { // Medium screens
                        width: "75%",
                    },
                    ["@media (max-width:600px)"]: { // Small screens
                        width: "90%",
                    },
    },
    closeButton: {
        position: 'absolute',
        top: 30,
        right: 30,
        cursor: 'pointer',
        fontSize: '16px',
        color: '#717680',
    },
    iconContainer: {
        width: 56,
        height: 56,
        borderRadius: '50%',
        border: "8px solid #fef3f2",
        backgroundColor: '#FEE4E2',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        mr: 2,
    },
    title: {
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '18px',
        color: '#181D27',
        lineHeight: '28px',
    },
    description: {
        textAlign: 'left',
        fontWeight: '400',
        fontSize: '14px',
        color: '#535862',
        lineHeight: '20px',
    },
    buttonContainer: {
        mt: 4,
        display: 'flex',
        justifyContent: 'flex-end',
    },
    cancelButton: {
        mr: 1,
        color: '#414651',
        backgroundColor: 'white',
        borderRadius: '8px',
        border: '1px solid #d5d7da',
        '&:hover': {
            backgroundColor: 'white',
            border: '1px solid #d5d7da',
        },
    },
    blockButton: {
        backgroundColor: '#d92d20',
        color: 'white',
        borderRadius: '8px',
        '&:hover': {
            backgroundColor: '#d92d20',
        },
    },
    cancelIcon: {
        width: 12,
        height: 12,
    }
    ,   deleteIcon: {
        width: 18,
        height: 20,
    }
};
